"use client";
import { Fragment } from "react";
import { CardHeader, Stack, Avatar, Box } from "@mui/material";
import { PapersIcon } from "../Icon/Papers";

import FilledCard from "./Filled";
import ChipInfo from "../Chip/Info";
import { ModelIcon } from "../Icon/Model";
import { useStore, observer } from "../../service/mobx";

export const CardUserSize2 = observer(function CardUserSize2({ user }) {
  const { reader } = useStore();
  const name = user.name?.toLowerCase();
  const emailNode = reader.paperNode?.emailsConnection?.edges?.find(
    ({ author, node }) =>
      (!!author && author.toLowerCase() === name) ||
      (!!node.name && node.name?.toLowerCase() === name)
  );

  return (
    <FilledCard
      thin
      raise={false}
      tone="var(--surface-container-lowest)"
      sx={{
        border: 1,
        borderColor: "var(--outline-variant)",
        borderRadius: "var(--shape-sm)"
      }}
    >
      <CardHeader
        avatar={<UserAvatar />}
        title={name}
        titleTypographyProps={{
          variant: "labelMd",
          color: "var(--surface-on-color)",
          textTransform: "capitalize"
        }}
        subheader={<Subheader user={emailNode} />}
        sx={{ p: 0 }}
      />
    </FilledCard>
  );
});

const UserAvatar = ({ user, sx = {} }) => (
  <Avatar
    variant="rounded"
    src={user?.node?.avatar}
    sx={{
      bgcolor: "var(--surface-container-high)",
      ...sx
    }}
  />
);

function Subheader({ user }) {
  // const org = user?.node?.membership?.[0]?.name;
  const papers = user?.node?.paper?.length;
  const models = user?.node?.paper?.reduce(
    (count, paper) => count + paper.modelsAggregate.count,
    0
  );
  const items = [
    // org ? [org, () => null] : undefined,
    papers ? [papers, PapersIcon] : undefined,
    models ? [models, ModelIcon] : undefined
  ].filter(defined => defined);

  return (
    <Stack direction="row" alignItems="center" flexWrap="wrap" width="100%">
      {items.map(([content, Icon], index, array) => (
        <Fragment key={index}>
          <ChipInfo size="small" Icon={Icon} label={content} />
          {index + 1 === array.length ? undefined : (
            <Box color="var(--surface-on-color)" mx={0.5}>
              ·
            </Box>
          )}
        </Fragment>
      ))}
    </Stack>
  );
}
